/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogInputText } from "../../d-dialog-input-text";
import { DThemeDarkDialogInput } from "./d-theme-dark-dialog-input";

export class DThemeDarkDialogInputText
	extends DThemeDarkDialogInput
	implements DThemeDialogInputText {}
